import React from "react";
import "./index.css";
import { connect } from "react-redux";
import moment from "moment";
import NavigateNextOutlinedIcon from "@material-ui/icons/NavigateNextOutlined";
import NavigateBeforeOutlinedIcon from "@material-ui/icons/NavigateBeforeOutlined";
import { withRouter } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import CallIcon from "@material-ui/icons/Call";
import Button from "@material-ui/core/Button";
import DirectionsCarIcon from "@material-ui/icons/DirectionsCar";
import ProductFeedbackButton from "./ProductFeedback/ProductFeedbackButton";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";
import category from "../Menu/Category";

const mapStateToProps = (state) => {
  return {
    store: state.store.store,
    customTexts: state.store.store.settings.custom_texts,
    language: state.store.language,
    settings: state.store.store.settings,
    country_code: state.store.store.country_code,
  };
};

function Divider() {
  return (
    <div
      style={{
        backgroundColor: "#efefef",
        margin: "auto",
        height: 1,
        width: "90%",
      }}
    ></div>
  );
}
function getOptionsTotal(quantity, options, extraFields) {
  let total = options.reduce((total, option) => {
    return (
      total +
      ((option.quantity_exclusive && 1) || quantity) *
        (option.price * option.quantity)
    );
  }, 0);

  total = extraFields.reduce((total, extraField) => {
    return (
      total +
      extraField.price * ((extraField.quantity_exclusive && 1) || quantity)
    );
  }, total);
  return total;
}
const isHTML = (value) =>
  typeof value === "string" && /<\/?[a-z][\s\S]*>/i.test(value);
const SubTotal = connect(mapStateToProps)(
  ({ subtotal, language, settings,currency,isSaudi ,currencyIcon}) => {
    return (
      <div
        className="row"
        style={{
          backgroundColor: "white",
          margin: 0,
          minHeight: 28,
          position: "relative",
        }}
      >
        <div className="col-2"></div>
        <div className="col-7">
          <div className="center-y">
            {language == "english" ? "Subtotal" : "المجموع"}
          </div>
        </div>
        <div className="col-3">
          <span
            className={`"center-x-y" ${currencyIcon}`}
            style={{ fontWeight: "bold", whiteSpace: "nowrap" }}
          >
            {subtotal.toFixed(settings.base_currency_decimals)}{" "}
            {isSaudi
              ? ""
              : currency}
          </span>
        </div>
      </div>
    );
  }
);

function getOrderedOptions(options) {
  const orderedList = [];
  const children = [];

  options.forEach((op) => {
    if (op.choice_parent && op.option_parent) {
      children.push(op);
    } else {
      op.children = [];
      orderedList.push(op);
    }
  });
  if (children) {
    children.forEach((op) => {
      let parent = orderedList.find(
        (o) =>
          o.choice_id == op.choice_parent &&
          o.option_id === op.option_parent &&
          (!op.group_id || o.group_id === op.group_id)
      );
      if (parent) {
        op.children = [];
        parent.children.push(op);
      } else {
        op.children = [];
        orderedList.push(op);
      }
    });
  }

  return orderedList;
}

const OrderItemOption = connect(mapStateToProps)(
  ({ option, language, settings, itemQuantity, child,isSaudi,currency,currencyIcon }) => {
    return (
      <>
        <div
          className="row"
          style={{
            backgroundColor: "white",
            margin: 0,
            minHeight: 28,
            position: "relative",
          }}
        >
          <div className="col-2">
            <span className="center-x-y">
              x
              {(option.quantity_exclusive && option.quantity) ||
                option.quantity * itemQuantity}
            </span>
          </div>
          <div className="col-7">
            <div
              className="center-y cut-text-one-line-tracking"
              style={{
                textAlign: language == "english" ? "left" : "right",
                position: "relative",
                paddingRight: (child && language == "arabic" && 10) || 0,
                paddingLeft: (child && language == "english" && 10) || 0,
              }}
            >
              {child && "–"}{" "}
              {language == "english" ? option.option : option.ar_option}:{" "}
              {language == "english" ? option.value : option.ar_value}
            </div>
          </div>
          <div className="col-3">
            <span
              className={`"center-x-y" ${currencyIcon}`}
              style={{ whiteSpace: "nowrap" }}
            >
              {(option.quantity * option.price).toFixed(
                settings.base_currency_decimals
              )}{" "}
              {isSaudi
                ? ""
                : currency}
            </span>
          </div>
        </div>
        {option.children?.map((op) => (
          <OrderItemOption
            key={Math.floor(Math.random() * 100000)}
            option={op}
            itemQuantity={itemQuantity}
            child={true}
            isSaudi={isSaudi}
            currecny={currency}
            currencyIcon={currencyIcon}
          />
        ))}
      </>
    );
  }
);

const OrderItemExtraField = connect(mapStateToProps)(
  ({ extraField, language, settings, itemQuantity,isSaudi,currency,currencyIcon }) => {
    // const isSaudi = settings.base_currency === "SAR";
    return (
      <div
        className="row"
        style={{
          backgroundColor: "white",
          margin: 0,
          minHeight: 28,
          position: "relative",
        }}
      >
        <div className="col-2">
          <span className="center-x-y">
            x{extraField.quantity_exclusive ? 1 : itemQuantity}
          </span>
        </div>
        <div className="col-7">
          <div
            className="center-y cut-text-one-line-tracking"
            style={{
              textAlign: language == "english" ? "left" : "right",
              position: "relative",
            }}
          >
            {language == "english" ? extraField.name : extraField.ar_name}:{" "}
            {isHTML(extraField.value) ? (
              <div
                dangerouslySetInnerHTML={{ __html: extraField.value }}
                style={{
                  maxHeight: 150,
                  overflow: "auto",
                  padding: 8,
                  border: "1px solid #ddd",
                  borderRadius: 4,
                }}
              />
            ) : (
              <>{extraField.value}</>
            )}
          </div>
        </div>
        <div className="col-3">
          <span
            className={`"center-x-y" ${currencyIcon}`}
            style={{ whiteSpace: "nowrap" }}
          >
            {extraField.price.toFixed(settings.base_currency_decimals)}{" "}
            {isSaudi
              ? ""
              : currency}
          </span>
        </div>
      </div>
    );
  }
);
const OrderItemBookable = connect(mapStateToProps)(({ item, language }) => {
  return (
    <div
      className="row"
      style={{
        backgroundColor: "white",
        margin: 0,
        minHeight: 48,
        position: "relative",
      }}
    >
      <div className="col-2"></div>
      <div className="col-10 d-flex">
        <div
          className="my-auto cut-text-one-line-tracking"
          style={{ textAlign: language == "english" ? "left" : "right" }}
        >
          {language == "english" ? "Booked for:" : "محجوز:"}
          <br />
          <span className="bold">
            {item.booking_is_all_day
              ? language == "english"
                ? "All day"
                : "طوال اليوم"
              : `${item.booking_date}, ${moment(
                  item.booking_start,
                  "HH:mm:ss"
                ).format("h:mm A")} ${
                  (language == "arabic" && "إلى") || "to"
                } ${moment(item.booking_end, "HH:mm:ss").format("h:mm A")}`}
          </span>
        </div>
      </div>
    </div>
  );
});

const OrderItemService = connect(mapStateToProps)(({ item, language }) => {
  const translateSlotText = (text) => {
    if (language == "english") return text;

    let temp = text.replace(/PM/g, "م");
    temp = temp.replace(/AM/g, "ص");
    return temp;
  };

  const translateDate = (date) => {
    if (language == "english") return date;

    const ar_months = {
      January: "يناير ",
      February: "فبراير",
      March: "مارس",
      April: "أبريل",
      May: "مايو",
      June: "يونيو",
      July: "يوليو",
      August: "أغسطس",
      September: "سبتمبر",
      October: "أكتوبر",
      November: "نوفمبر",
      December: "ديسمبر",
    };
    let temp = date;
    Object.keys(ar_months).forEach((month) => {
      temp = temp.replace(month, ar_months[month]);
    });
    return temp;
  };

  return (
    <div
      className="row"
      style={{
        backgroundColor: "white",
        margin: 0,
        minHeight: 48,
        position: "relative",
      }}
    >
      <div className="col-2"></div>
      <div className="col-10 d-flex" style={{ flexFlow: "wrap" }}>
        <div
          className="my-auto cut-text-one-line-tracking"
          style={{ textAlign: language == "english" ? "left" : "right" }}
        >
          {language == "english" ? "Booked with:" : "محجوز مع:"}{" "}
          <span className="bold">
            {language == "english"
              ? item.resource.name
              : item.resource.ar_name || item.resource.name}
          </span>
          <br />
          <p className="mb-0">
            {language == "english" ? "Date" : "التاريخ"}:{" "}
            {translateDate(
              moment(item.booking_date, "YYYY-MM-DD").format("LL")
            )}
          </p>
          <p className="mb-0">
            {language == "english" ? "Time" : "الوقت"}:{" "}
            {translateSlotText(
              `${moment(item.booking_start, "HH:mm:ss").format(
                "h:mm A"
              )} - ${moment(item.booking_end, "HH:mm:ss").format("h:mm A")}`
            )}
          </p>
        </div>
        <div
          className="my-auto cut-text-one-line-tracking"
          style={{
            textAlign: language == "english" ? "left" : "right",
          }}
        >
          {!!item.resource_location?.lat && !!item.resource_location?.lng && (
            <>
              <br />
              {language == "english" ? "Location:" : "العنوان:"}{" "}
              <Button
                color="primary"
                endIcon={language == "english" && <DirectionsCarIcon />}
                startIcon={
                  language == "arabic" && (
                    <DirectionsCarIcon
                      style={{ marginLeft: 8, marginRight: 0 }}
                    />
                  )
                }
                style={{ textTransform: "none", padding: 0 }}
                onClick={() => {
                  var win = window.open(
                    `https://maps.google.com/maps?daddr=${item.resource_location.lat},${item.resource_location.lng}`,
                    "_blank"
                  );
                  win.focus();
                }}
              >
                <span>
                  {language == "english"
                    ? "Get directions"
                    : "الحصول على الاتجاهات"}
                </span>
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
});

const OrderItemSpecialRemark = connect(mapStateToProps)(
  ({ item, language }) => {
    return (
      <div
        className="row"
        style={{
          backgroundColor: "white",
          margin: 0,
          minHeight: 17,
          position: "relative",
        }}
      >
        <div className="col-2"></div>
        <div className="col-10 d-flex">
          <div
            style={{
              textAlign: language == "english" ? "left" : "right",
              marginTop: 10,
            }}
          >
            {item.special_remarks && (
              <>
                <span className="bold">
                  {language == "english" ? "Remarks: " : "ملاحظات: "}
                </span>

                <span>{item.special_remarks}</span>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
);

const OrderItem = connect(mapStateToProps)(({ item, settings, language,currency,isSaudi,currencyIcon }) => {
  const orderedOptions = getOrderedOptions(item.options);
  return (
    <div className="pt-3">
      <div
        className="row"
        style={{
          backgroundColor: "white",
          margin: 0,
          minHeight: 28,
          position: "relative",
        }}
      >
        <div className="col-2 d-flex">
          <span className="m-auto">x{item.quantity}</span>
        </div>
        <div className="col-7 d-flex">
          <p
            style={{
              fontWeight: "bold",
              margin: 0,
              textAlign: language == "english" ? "left" : "right",
            }}
            className="my-auto cut-text-one-line-tracking"
          >
            {language == "english" ? item.name : item.ar_name || item.name}
          </p>
        </div>
        <div className="col-3 d-flex">
          <span
            className={`m-auto ${currencyIcon}`}
            style={{ whiteSpace: "nowrap" }}
          >
            {(item.quantity * item.price).toFixed(
              settings.base_currency_decimals
            )}{" "}
            {isSaudi
              ? ""
              : currency}
          </span>
        </div>
      </div>
      {item.type_of_product == "service" &&
      item.resource &&
      item.booking_date &&
      item.booking_start &&
      item.booking_end ? (
        <OrderItemService item={item} />
      ) : null}
      {item.type_of_product == "bookable" &&
      item.booking_date &&
      item.booking_start &&
      item.booking_end ? (
        <OrderItemBookable item={item} />
      ) : null}
      {orderedOptions.map((option) => (
        <OrderItemOption
          key={Math.floor(Math.random() * 100000)}
          option={option}
          itemQuantity={item.quantity}
          child={false}
          currency={currency}
          isSaudi={isSaudi}
          currencyIcon={currencyIcon}
        />
      ))}
      {item.extra_fields.map((extraField) => (
        <OrderItemExtraField
          key={Math.floor(Math.random() * 100000)}
          extraField={extraField}
          itemQuantity={item.quantity}
          currency={currency}
          isSaudi={isSaudi}
          currencyIcon={currencyIcon}
        />
      ))}
      {item.special_remarks && <OrderItemSpecialRemark item={item} />}
      <SubTotal
        currency={currency}
        isSaudi={isSaudi}
        currencyIcon={currencyIcon}
        subtotal={
          item.quantity * item.price +
          getOptionsTotal(item.quantity, item.options, item.extra_fields)
        }
      />
      <div style={{ marginTop: 12 }}></div>
      <Divider />
    </div>
  );
});

function OrderDetails({
  store,
  order,
  customTexts,
  history,
  language,
  settings, country_code
}) {
  let isSaudi = ["SAR", "AED"].includes(settings.base_currency);
  const additionalFee = Number(order.additional_fee) || 0;

  const isos = {
    kw: "KD",
    bh: "BD",
    qa: "QR",
    sa: "SAR",
    sar: "SAR",
    om: "OMR",
    ae: "AED",
    us: "USD",
    eu: "EUR",
    gp: "GBP",
  };
  let currencyIcon = ""
  const getCurrency = () => {
    const baseCurrency =
      language === "english"
        ? settings.base_currency
        : settings.base_currency_local;

    // If the currency converter is disabled, return the base currency directly
    if (!settings.enable_currency_converter) return baseCurrency;

    const code = country_code?.toLowerCase();
    const converted = order?.converted_currency?.toLowerCase();
    const base = settings?.base_currency?.toLowerCase();

    const saudiUaeCodes = ["sar", "sa", "aed","ae"];

    const setSaudiCurrency = (currency) => {
      isSaudi = true;
      currencyIcon = ["sar", "sa"].includes(currency) ? "icon-sar" : "icon-aed";
      return "";
    };

    // Case 1: When an order has a converted currency matching the base currency
    // if (converted && isos["kw"]?.toLowerCase() === base) {
    //   return saudiUaeCodes.includes(converted)
    //     ? setSaudiCurrency(converted)
    //     : isos[converted] || "KD";
    // }
    // Case 2: Use the country code if available
    if (code) {
      return saudiUaeCodes.includes(code)
        ? setSaudiCurrency(code)
        : isos[code] || "KD";
    }

    // Default fallback
    return baseCurrency;
  };

  const currency = getCurrency();

  return (
    <div
      className="border mt-4"
      style={{
        backgroundColor: "white",
        minHeight: 150,
        paddingRight: language == "english" && 5,
        paddingLeft: language == "arabic" && 5,
      }}
    >
      <div
        className="row py-3"
        style={{ margin: 0, marginBottom: 2, minHeight: 50 }}
      >
        <div className="col-2">
          <img
            className="center-x-y"
            src={store.logo}
            style={{ height: 30, width: 30, borderRadius: "50%" }}
          />
        </div>
        <div
          className={"col-10 ".concat(
            language == "english" ? "text-left" : "text-right"
          )}
        >
          <p
            style={{
              fontWeight: "bold",
              margin: 0,
              lineHeight: 2,
            }}
          >
            {language == "english" ? store.name : store.ar_name || store.name}{" "}
            {!!order.branch_name && (
              <>
                -{" "}
                <span className="bold">
                  {language === "arabic"
                    ? order.branch_name.ar_name
                    : order.branch_name.name}
                </span>
              </>
            )}
          </p>
          {!!order.branch_number &&
          !order.branch_number.includes("None") &&
          !settings.enable_car_qr &&
          !settings.enable_table_qr ? (
            <div className="mt-1">
              <a href={`tel:${order.branch_number}`}>
                <Button
                  color="primary"
                  //onClick={() => this.toggleDrawer(true)}
                  endIcon={language == "english" && <CallIcon />}
                  startIcon={
                    language == "arabic" && (
                      <CallIcon style={{ marginLeft: 8, marginRight: 0 }} />
                    )
                  }
                  style={{ textTransform: "none", padding: 0 }}
                >
                  <span>
                    {" "}
                    {language == "english"
                      ? "Questions? Call us"
                      : "للاستفسارات، اتصل بنا"}
                  </span>
                </Button>
              </a>
            </div>
          ) : null}
        </div>
      </div>
      <Divider />
      <Divider />
      <div className="pt-1">
        {order.items.map((item) => (
          <OrderItem key={Math.floor(Math.random() * 100000)} item={item} currency={currency} isSaudi={isSaudi} currencyIcon={currencyIcon} />
        ))}
      </div>
      <Divider />
      <div
        className="row"
        style={{ minHeight: 55, padding: "15px 5px", margin: 0 }}
      >
        {order.special_remarks && (
          <>
            <div className="col-3 d-flex" style={{ maxWidth: 120 }}>
              <span
                className=""
                style={{ fontWeight: "bold", whiteSpace: "nowrap" }}
              >
                {language == "english" ? "Remarks:" : "ملاحظات:"}
              </span>
            </div>
            <div
              className={"col-9 d-flex ".concat(
                language == "english" ? "text-left" : "text-right"
              )}
              style={{ maxWidth: "100%", flex: "1 0 65%", marginBottom: 8 }}
            >
              <span className="">{order.special_remarks}</span>
            </div>
          </>
        )}
        {order.is_gift &&
          order.gift_wrapping &&
          order.gift_wrapping_price > 0 && (
            <>
              <div className="col-9 d-flex">
                <span className="my-auto" style={{ fontWeight: "bold" }}>
                  {language == "english" ? "Gift Wrapping" : "تغليف الهدايا"}:
                </span>
              </div>
              <div className="col-3 d-flex">
                <span
                  className={`m-auto ${isSaudi && currencyIcon}`}
                  style={{ lineHeight: "28px", whiteSpace: "nowrap" }}
                >
                  {order.gift_wrapping_price.toFixed(
                    settings.base_currency_decimals
                  )}{" "}
                  {isSaudi
                    ? ""
                    : currency}
                </span>
              </div>
            </>
          )}
        {order.is_delivery && (
          <>
            <div className="col-9 d-flex">
              <span className="my-auto" style={{ fontWeight: "bold" }}>
                {language == "english"
                  ? customTexts.delivery_fee_text
                  : customTexts.delivery_fee_text_ar}
                :
              </span>
            </div>
            <div className="col-3 d-flex">
              <span
                className={`m-auto ${currencyIcon}`}
                style={{ lineHeight: "28px", whiteSpace: "nowrap" }}
              >
                {order.delivery_rate.toFixed(settings.base_currency_decimals)}{" "}
                {isSaudi
                  ? ""
                  : currency}
              </span>
            </div>
          </>
        )}
        {additionalFee > 0 && (
          <>
            <div className="col-9 d-flex">
              <span className="my-auto" style={{ fontWeight: "bold" }}>
                {settings.enable_table_qr
                  ? language === "arabic"
                    ? "اكرامية"
                    : "Tip"
                  : language == "english"
                  ? customTexts.additional_fee
                  : customTexts.additional_fee_ar}
                :
              </span>
            </div>
            <div className="col-3 d-flex">
              <span
                className={`m-auto ${currencyIcon}`}
                style={{ lineHeight: "28px", whiteSpace: "nowrap" }}
              >
                {additionalFee.toFixed(settings.base_currency_decimals)}{" "}
                {isSaudi
                  ? ""
                  : currency}
              </span>
            </div>
          </>
        )}
        {order.vat_rate > 0 && (
          <>
            {order.vat_with_product_price && (
              <>
                <div className="col-9 d-flex">
                  <span className="my-auto" style={{ fontWeight: "bold" }}>
                    {language == "english" ? "Gross Amount" : "المبلغ الإجمالي"}
                    :
                  </span>
                </div>
                <div className="col-3 d-flex">
                  <span
                    className={`m-auto ${currencyIcon}`}
                    style={{ lineHeight: "28px", whiteSpace: "nowrap" }}
                  >
                    {(order?.gross_amount).toFixed(
                      settings.base_currency_decimals
                    )}{" "}
                    {isSaudi
                      ? ""
                      : currency}
                  </span>
                </div>
              </>
            )}
            <div className="col-9 d-flex">
              <span className="my-auto" style={{ fontWeight: "bold" }}>
                {language == "english" ? "VAT" : "ضرائب"}:
              </span>
            </div>
            <div className="col-3 d-flex">
              <span
                className={`m-auto ${currencyIcon}`}
                style={{ lineHeight: "28px", whiteSpace: "nowrap" }}
              >
                {order.vat_amount.toFixed(settings.base_currency_decimals)}{" "}
                {isSaudi
                  ? ""
                  : currency}
              </span>
            </div>
          </>
        )}

        {order.discount_total > 0 && (
          <>
            <div className="col-9 d-flex">
              <span className="my-auto" style={{ fontWeight: "bold" }}>
                {language == "english" ? "Discount" : "الخصم"}:
              </span>
            </div>
            <div className="col-3 d-flex">
              <span
                className={`m-auto ${currencyIcon}`}
                style={{ lineHeight: "28px", whiteSpace: "nowrap" }}
              >
                {`${isSaudi ? "" : "-"}${order.discount_total.toFixed(
                  settings.base_currency_decimals
                )}
                ${
                  isSaudi
                    ? ""
                    : currency
                }`}
              </span>
            </div>
          </>
        )}

        <div className="col-9 d-flex">
          <span className="my-auto" style={{ fontWeight: "bold" }}>
            {language == "english" ? "Total:" : "المجموع:"}
          </span>
        </div>
        <div className="col-3 d-flex">
          <span
            className={`m-auto ${currencyIcon}`}
            style={{
              fontWeight: "bold",
              lineHeight: "28px",
              whiteSpace: "nowrap",
            }}
          >
            {order.total.toFixed(settings.base_currency_decimals)}{" "}
            {isSaudi
              ? ""
              : currency}
          </span>
        </div>
      </div>
      <Divider />
    </div>
  );
}

export default withRouter(connect(mapStateToProps)(OrderDetails));
